import React from 'react'
import store from '../../src/store'
import { withStyles } from '@material-ui/core/styles'
import { connect } from "react-redux";

import TreeView from '@material-ui/lab/TreeView'
import TreeItem from '@material-ui/lab/TreeItem'
import Typography from '@material-ui/core/Typography'
import NewReleasesIcon from '@material-ui/icons/NewReleases'
import DeleteIcon from '@material-ui/icons/Delete'
import Label from '@material-ui/icons/Label'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import HelpIcon from '@material-ui/icons/Help'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import LabelImportantIcon from '@material-ui/icons/LabelImportant'
import ListIcon from '@material-ui/icons/List'
import WebIcon from '@material-ui/icons/Web'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import Close from '@material-ui/icons/Close'
import SettingsIcon from '@material-ui/icons/Settings'
import WorkIcon from '@material-ui/icons/Work'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'

import PanelGroup from "react-panelgroup"
import Splashpage from '../Splashpage'

import AccountManager from './AccountManager'
import AccountManagerWizard from './AccountManagerWizard'
import AddBusinessListing from './AddBusinessListing'
import ClassifiedWizard from './ClassifiedWizard'
import ListingManager from './ListingManager'

import EditSplash from '../EditSplash'
import EditSplashRotate from './EditSplashRotate'

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'


import CategoryManagement from '../../src/CategoryManagement'

import { db2modes } from '../Modes'


import { getAdvertisersListingsForUser, APIUpdateAdvertiser, setAdvertiserId, login } from '../apis'
import moment from 'moment';
import { Toolbar } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

const treeWidth = 282
const header = 90

const features_ready = [
    //    'Post Jobs',
    //    'Edit Splashpage',
    //    'Listing Advertising',
    //    'Account Delegates'
]

const styles = {
    page: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        height: (window.innerHeight - header) + 'px',
        overflow: 'hidden',
    },
    treepanel: {
        flexBasis: 400,
    },
    tabbody: {
        height: (window.innerHeight - 75) + 'px',
        padding: '3px !important',
    },
    tabpanel: {
        width: '100%',
        borderLeft: '2px solid #000',
        height: (window.innerHeight - header) + 'px',
        overflowX: 'auto',
        flex: 'flex-grow',
    },
    tabs: {
        minHeight: '20px !important',
        height: '20px !important',
        maxHeight: '20px !important',
        marginTop: '5px',
        borderBottom: '2px solid #339',
    },
    tab: {
        minHeight: '20px !important',
        height: '20px !important',
        maxHeight: '20px !important',
        paddingLeft: '20px',
        paddingRight: '0px',
        margin: '0px',
        marginRight: '3px',
        marginTop: '3px',
        minWidth: 'unset',
        borderTopRightRadius: '7px',
        borderTopLeftRadius: '7px',
        backgroundColor: '#339',
        color: '#fff',
        whiteSpace: 'nowrap',
        maxWidth: '50%',
    },

    group: {
        marginLeft: 0,
        '& $content': {
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
    },
    comingsoon: {
        display: 'flex',
        alignItems: 'center',
    },
    labelIcon: {
    },
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
    labelTextDisabled: {
        fontWeight: 'inherit',
        flexGrow: 1,
        color: '#ccc',
    },
    flextabs: {
        width: '300px',
        backgroundColor: '#fc0',
    },
    labelinactive: {
        textDecoration: 'line-through',
    },
    tb: {
        minHeight: 20,
    },
    folder: {
        width: '25px',
    },
}


function TabPanel(props) {
    const { children, value, index, ...other } = props
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {children}
        </div>
    )
}

const StyledTreeItem = (props) => {
    const classes = props.cls
    const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, level, disabled, ...other } = props
    const children = props.children || []
    return (
        <TreeItem
            label={
                <div className={classes.labelRoot}>
                    <LabelIcon color="inherit" className={classes.labelIcon} />
                    <Typography variant="body2" className={disabled ? classes.labelTextDisabled : classes.labelText}>
                        {labelText}
                    </Typography>
                </div>
            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
                paddingLeft: parseInt(level) <= 2 || (children && Array.isArray(children) && children.length) ? parseInt(level || 0) * 20 + 'px' : '0px',
            }}
            classes={{
                root: classes.root,
                content: classes.content,
                expanded: classes.expanded,
                selected: classes.selected,
                group: classes.group,
                label: classes.label,
            }}
            {...other}
        />
    )
}

const ListingTreeItem = (props) => {
    const { classes, text, c, advertiser_id, listing_id, name, addtab, disableall, user_role, splashpageenabled } = props
    let splashpage = !splashpageenabled ? [] : features_ready.indexOf('Edit Splashpage') < 0 && user_role != 'admin' ? '' : <StyledTreeItem
        nodeId={c + ".5"}
        level='3'
        labelText='Edit Splashpage'
        labelIcon={WebIcon}
        labelInfo="90"
        color="#1a73e8"
        cls={classes}
        disabled={disableall}
        bgColor="#e8f0fe"
        onLabelClick={(event) => {
            event.preventDefault()
            this.addtab({
                type: 'splash',
                label: name + ' (Splash Page)',
                id: advertiser_id + '-' + listing_id,
            })
        }}
    />
    let advertising = features_ready.indexOf('Listing Advertising') < 0 ? '' : <StyledTreeItem
        nodeId={c + ".6"}
        labelText="Listing Advertising"
        level='3'
        labelIcon={MonetizationOnIcon}
        labelInfo="90"
        color="#1a73e8"
        cls={classes}
        disabled={disableall}
        bgColor="#e8f0fe"
        onLabelClick={(event) => {
            event.preventDefault();
            this.addtab({
                type: 'advertising',
                label: name + ' (Advertising)',
                id: advertiser_id + '-' + listing_id,
            })
        }}
    />
    let jobs = features_ready.indexOf('Post Jobs') < 0 ? '' : <StyledTreeItem
        nodeId={c + ".7"}
        labelText="Post Jobs"
        level='3'
        labelIcon={WorkIcon}
        labelInfo="90"
        disabled={disableall}
        color="#1a73e8"
        cls={classes}
        bgColor="#e8f0fe"
        onLabelClick={(event) => {
            event.preventDefault();
            this.addtab({
                type: 'postjobs',
                label: name + ' (Post Jobs)',
                id: advertiser_id + '-' + listing_id,
            })
        }}
    />


    return (
        <StyledTreeItem
            nodeId={c + ".4"}
            labelText={text}
            labelIcon={ListIcon}
            labelInfo="90"
            level='2'
            color="#1a73e8"
            cls={classes}
            bgColor="#e8f0fe"
            onLabelClick={(event) => {
                event.preventDefault();
                this.addtab({
                    type: 'listing',
                    label: name + ' (Listing)',
                    id: advertiser_id + '-' + listing_id,
                })
            }}
        >
            {splashpage}
            {advertising}
            {jobs}
        </StyledTreeItem>
    )
}

class AccountAdmin extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tabvalue: 0,
            tree: [],
            tabs: ['News & Announcements'],
            tabpanels: [<Splashpage listing_id={-11} page_name='Admin News And Updates' />],
            expanded: undefined,
            selected: undefined,
            selectedtype: undefined,
            newlistings: {},
            hasAccount: false,
        }
        this.enableClassifieds = true
        this.preserve = false
        this.c = 1
        this.opened = ['News & Announcements_']
    }

    closetab = (i) => {
        this.preserve = true
        let tabvalue = this.state.tabvalue
        if (true) { //window.confirm('Are you sure you want to close this tab?')) {
            let tabs = this.state.tabs
            tabs.splice(i, 1)
            let tabpanels = this.state.tabpanels
            tabpanels.splice(i, 1)
            if (i <= tabvalue && tabvalue > 0) tabvalue--
            this.opened.splice(i, 1)
            this.setState({ tabs, tabpanels, tabvalue })
            return false
        }
    }

    reload = (leaveOpen) => {
        if ( ! leaveOpen ) this.closetab(this.state.tabvalue)
        this.loadtree()
    }

    addtab = ({type, label, id, cb, mode_override}) => {
        mode_override = mode_override || 'Businesses'
        if (!cb) cb = (res) => { }
        this.treeselected(type, id)
        if (this.opened.indexOf(type + '_' + id) >= 0) {
            this.setState({ tabvalue: this.opened.indexOf(type + '_' + id) })
            return
        }
        var { tabpanels, tabs } = this.state
        var page = undefined
        if (type == 'News & Announcements') page = <Splashpage listing_id={-11} page_name='Admin News And Updates' />
        if (type.indexOf(' Help') > 0) {
            page = <Splashpage listing_id={-11} page_name={type} />
        }
        let actions = {
            account: AccountManager,
            accountWizard: AccountManagerWizard,
            addBusinessListing: AddBusinessListing,
            classifiedWizard: ClassifiedWizard,
            classifiedWizardb: ClassifiedWizard,
            listing: ListingManager,
            splash: EditSplash, //Rotate,
            advertising: AccountManager,
            postjobs: AccountManager,
            delegates: AccountManager,
            jobcenter: AccountManager,
            CategoryManagement: CategoryManagement,
        }
        if (!page) {
            var key = type + '_' + id
            var El = actions[type]
            page = <El key={key} id={id} cb={cb} reload={this.reload} business={type == 'classifiedWizardb'} size={this.state.accountWindowSize} mode_override={mode_override} />
        }
        tabs.push(label)
        tabpanels.push(page)
        this.setState({ tabs, tabpanels, tabvalue: tabs.length - 1 })
        this.opened.push(type + '_' + id)
        console.log('tabpanels')
        console.log(tabpanels)
        return false
    }

    handleChange = (event, newValue) => {
        if (!this.preserve) this.setState({ tabvalue: newValue })
        this.preserve = false
    }

    // handleTreeClick = (nevent, treestate) => {
    //     this.setState({ treestate })
    // }

    componentDidMount() {
        this.loadtree()
    }
    
    componentDidUpdate(prevprops) {
        const { classes } = this.props
        if (prevprops.reload_tree_id != this.props.reload_tree_id) {
            this.opened = ['News & Announcements_']
            this.preserve = false
            this.c = 1
            // this.closetab(i)
            let tabs = [...this.state.tabs]
            let tabpanels = this.state.tabpanels
            let tabvalue = this.state.tabvalue
            this.state.tabs.forEach((x, i) => {
                if ( x.indexOf('--') == 0 ) {
                    tabs.splice(i, 1)
                    tabpanels.splice(i, 1)
                    if (i <= tabvalue && tabvalue > 0) tabvalue--
                    this.opened.splice(i, 1)
                }
            })
            console.log('here are the tabs')
            console.log(tabs)
            this.setState({
                tabs,
                tabpanels,
                tabvalue,
                tree: [],
                tabvalue,
                expanded: undefined,
                selected: undefined,

            }, () => this.reload())

        }        
    }
    
    adjustOpen = (id, res) => {
        console.log('adjusting')
        console.log(id)
        console.log(res)
    }

    drag = (e) => {
        e.dataTransfer.setData("text", e.target.id);
    }

    loadtree = () => {
        const { classes } = this.props
        const mode2NodeMapping = {
            'myocg': 1442,
            'classifieds': 2442,
            'pc_myocg': 2443,
            'pc_b2b': 2444,
            'pc_industrial': 2445,
            'industrial': 1443,
            'b2b': 1444,
            'thingstodo': 2446,
            'jobcenter': 2447,
            'shopping': 2448,
            'outdoors': 2449,
            'events': 2450,
            'coupons': 2451,
        }
        login(localStorage.getItem('auth'), () => {
            let tree = {}
            let id = 3000
            let treeorder = ['top']
            getAdvertisersListingsForUser((res) => {
                console.log('lsitings!!!')
                console.log(res)
                let isPayingAdvertiser = false
                res.advertisers.filter(x => x.mode == 'Businesses').forEach(advertiser => {
                    advertiser.listings.forEach(listing => {
                        if (listing.active == 'Y') isPayingAdvertiser = true
                    })
                })

                Object.keys(db2modes).forEach(mode => {
                    let info = db2modes[mode]
                    treeorder[info.order] = mode
                    let advertisers = []
                    console.log('----')
                    console.log(res.advertisers)
                    console.log(info.mode)
                    res.advertisers.filter(x => x.mode == info.mode).forEach(advertiser => {
                        let listings = []
                        advertiser.listings.forEach(listing => {
                            let more = info.mode == 'Classifieds' || info.mode.indexOf(' Classifieds') > 0 ? <span> {listing.cost_override} - {listing.primary_category_name} </span> : <div style={{ fontSize: '.85em', paddingLeft: '15px' }}>
                                {listing.address || listing.web_address}<br />
                                {listing.city}, {listing.state}  {listing.zip}
                            </div>
         
                            let splashpage = info.splashPageEnabled && this.props.user_role == 'admin' ? <StyledTreeItem
                                nodeId={id + ".5"}
                                level='3'
                                labelText='Edit Splashpage'
                                labelIcon={WebIcon}
                                labelInfo="90"
                                color="#1a73e8"
                                cls={classes}
                                bgColor="#e8f0fe"
                                onLabelClick={
                                    (event) => {
                                        event.preventDefault();
                                        this.addtab({
                                            type: 'splash',
                                            label: listing.name + ' (Splash Page)',
                                            id: listing.advertiser_id + '-' + listing.listing_id
                                        })
                                    }
                                }
                            /> : ''
                            listings.push(<TreeItem
                                nodeId={id}
                                advertiserId={listing.advertiser_id}
                                listingId={listing.listing_id}
                                onLabelClick={(event) => { 
                                    this.addtab({
                                        type: 'listing',
                                        label: listing.name + ' (Listing)',
                                        id: listing.advertiser_id + '-' + listing.listing_id,
                                        mode_override: info.mode
                                    })
                                }}
                                label={
                                    <div className={(listing.active == 'Y' && moment(listing.end_date) >= moment()) ? classes.label : classes.labelinactive}>
                                        {listing.name}
                                        {more}
                                    </div>
                                }
                            >
                                {splashpage}
                            </TreeItem>
                                )
                                id++
                        })
                        if (info.suppressAccount) {
                            advertisers.push(listings)
                        }
                        else {
                            advertisers.push(<TreeItem
                                nodeId={id}
                                label={
                                    <div draggable={true} ondragstart={this.drag}>
                                        {advertiser.business_name}
                                    </div>
                                }
                            >
                                {listings}
                            </TreeItem>
                            )
                            id++
                        }
                    })
                    console.log('------------------------')
                    console.log(info.mode)
                    console.log(advertisers)
                    let LabelIcon = info.icon
                    let addButtonEnabled = info.mode.indexOf(' Classifieds') > 0 ? isPayingAdvertiser : true
                    if ( info.listingLimit && advertisers.filter(x => info.suppressAccount ? x.length : x).length >= info.listingLimit ) addButtonEnabled = false
                    if ( this.props.user_role == 'admin' ) addButtonEnabled = true
                    let newItem = mode2NodeMapping[mode] && addButtonEnabled ? <TreeItem
                        nodeId={id + '.6'}
                        label={<div><AddCircleOutlineIcon fontSize='small'/> Create {info.text} Listing</div>}
                        onLabelClick={(event) => { event.preventDefault(); this.newaccount(mode2NodeMapping[mode]) }}
                    /> : []

                    tree[mode] = [
                        <TreeItem
                            nodeId={id}
                            onLabelClick={(event) => {
                                this.addtab({
                                    type: info.text + ' Help',
                                    label: info.text + ' Help',
                                })
                            }}
                            onIconClick={(event) => {
                                this.addtab({
                                    type: info.text + ' Help',
                                    label: info.text + ' Help',
                                })
                            }}
                            label={
                                <div className={info.comingSoon ? classes.comingsoon : classes.labelRoot}>
                                    <LabelIcon />
                                    {info.text == 'Classifieds' ? 'Consumer ' + info.text : info.text} {info.comingSoon ? <div style={{color: '#9cc', paddingLeft: '5px'}}> Coming soon!</div> : ''}
                                    &nbsp;({advertisers.filter(x => info.suppressAccount ? x.length : x).length})
                                </div>
                            }
                        >
                            {newItem}
                            {advertisers}
                        </TreeItem>
                    ]
                    tree[mode].push(<Divider />)
                    id++
                })
                tree.top = []
                if (this.props.user_role == 'admin') {
                    tree.top.push(<StyledTreeItem 
                        nodeId="1400.0" 
                        labelText="Manage Categories" 
                        labelIcon={SettingsIcon} 
                        cls={this.props.classes} 
                        onLabelClick={(event) => {
                            event.preventDefault(); 
                            this.addtab({
                                type: 'CategoryManagement',
                                label: 'CategoryManagement',
                            })
                        }}
                    />)
                }
                tree.top.push(<Divider />)
                let bigTree = []
                treeorder.forEach(level => {
                    bigTree = [...bigTree, ...tree[level]]
                })
                console.log('bigTree')
                console.log({bigTree})
                this.setState({ tree: bigTree.length ? [...bigTree] : [] })
            })
        })
    }

    treeselected = (type, id) => {
        this.setState({ selectedtype: type, selected: id })
        if (type == 'account') {
            setAdvertiserId(id, () => { })
        }
    }

    updateConsumerId = (id, res) => {
    }

    updateAccountId = (id, res) => {
        console.log('updating account id')
        console.log(this.opened)
        console.log(id)
        console.log(res)
        let tabs = this.state.tabs.filter((row) => { return row != '--NEW-- (Account)' })
        this.opened = this.opened.filter((row) => { return row != 'account_--NEW--' })
        let tabpanels = this.state.tabpanels.filter((row) => { return row.key != 'account_--NEW--' })
        this.setState({ tabs, tabpanels }, () => {
            this.loadtree()
            this.addtab({
                type: 'account',
                label: res.business_name + ' (Account)',
                id: res.advertiser_id,
            })
        })
    }

    updateClassifiedId = (id, res, business) => {
        console.log('updating account id')
        console.log(this.opened)
        console.log(id)
        console.log(res)
        let tabs = this.state.tabs.filter((row) => { return row != '--NEW-- (Classified)' })
        this.opened = this.opened.filter((row) => { return row != 'classified_--NEW--' })
        let tabpanels = this.state.tabpanels.filter((row) => { return row.key != 'classified_--NEW--' })
        let b = business ? 'Business ' : ''
        this.setState({ tabs, tabpanels }, () => {
            this.loadtree()
            this.addtab({
                type: business ? 'bclassified' : 'classified',
                label: res.business_name + ' (' + b + 'Classified)',
                id: res.advertiser_id,
            })
        })
    }

    updateClassifiedbId = (id, res) => {
        this.updateClassifiedId(id, res, true)
    }

    newaccount = (nodeId) => {
        var { classes } = this.props
        //nodeId=""
        console.log('free')
        console.log(this.state.tree)
        let tree = this.state.tree
        let i = tree.findIndex(t => t.props.nodeId == nodeId)
        this.c = this.c + 1
        let id = '--NEW--' + nodeId

        if (nodeId == '1442') {
            this.setState({ tree },
                () => this.addtab({
                    type: 'accountWizard',
                    label: '--NEW-- (Account)',
                    id: id,
                    cb: this.updateAccountId,
                    mode_override: 'myocg',
                })
            )
        }
        else if (nodeId == '1443') {
            this.setState({ tree },
                () => this.addtab({
                    type: 'accountWizard',
                    label: '--NEW-- (Account)',
                    id: id,
                    cb: this.updateAccountId,
                    mode_override: 'industrial',
                })
            )
        }
        else if (nodeId == '1444') {
            this.setState({ tree },
                () => this.addtab({
                    type: 'accountWizard',
                    label: '--NEW-- (Account)',
                    id: id,
                    cb: this.updateAccountId,
                    mode_override: 'b2b',
                })
            )
        }
        else if (nodeId == '2446' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizardb',
                    label: '--NEW-- (Things To Do)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'thingstodo',
                })
            )
        }
        else if (nodeId == '2447' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Job Center)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'jobcenter',
                })
            )
        }
        else if (nodeId == '2448' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Shopping)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'shopping',        
                })
            )
        }
        else if (nodeId == '2449' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Outdoors)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'outdoors',
                })
            )
        }
        else if (nodeId == '2450' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Events)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'events',
                })
            )
        }
        else if (nodeId == '2451' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Coupons)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'coupons',
                })
            )
        }
        else if (nodeId == '2442' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizard',
                    label: '--NEW-- (Classified)',
                    id: id,
                    cb: this.updateClassifiedId,
                    mode_override: 'classifieds',
                })
            )

        }
        else if (nodeId == '2443' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizardb',
                    label: '--NEW-- (Business Product Connect)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'pc_myocg',
                })
            )
        }
        else if (nodeId == '2444' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizardb',
                    label: '--NEW-- (B2B Product Connect)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'pc_b2b',
                })
            )
        }
        else if (nodeId == '2445' && this.enableClassifieds) {
            this.setState({ tree },
                () => this.addtab({
                    type: 'classifiedWizardb',
                    label: '--NEW-- (Industrial Product Connect)',
                    id: id,
                    cb: this.updateClassifiedbId,
                    mode_override: 'pc_industrial',
                })
            )
        }
    }

    newlisting = (e) => {
        var { classes } = this.props
        let tree = this.state.tree || []
        console.log('tree')
        console.log(tree)
        console.log(e.target)
        let accountId = this.state.selected
        var newlistings = this.state.newlistings
        if (!newlistings[accountId]) {
            newlistings[accountId] = []
        }
        //newlistings[accountId].push(this.state.updatenum)
        this.setState({ newlistings: {...newlistings} }, () => {
            this.loadtree()
            this.addtab({
                type: 'listing',
                label: '--NEW-- (Listing)',
                id: '--NEWLISTING--',
                cb: this.addListingToAccount,
            })
        })
    }

    addListingToAccount = (id, res) => {
        console.log('updating listing id')
        console.log(this.opened)
        console.log(id)
        console.log(res)
        console.log(this.state.tabs)
        console.log(this.state.tabpanels)
        console.log(this.opened)
        let tabs = this.state.tabs.filter((row) => { return row != '--NEW-- (Listing)' })
        this.opened = this.opened.filter((row) => { return row && row.indexOf('--NEWLISTING--') == -1 && row.indexOf('undefined') == -1 })
        let tabpanels = this.state.tabpanels.filter((row) => { return !row.key || (row.key && row.key.indexOf('--NEWLISTING--') == -1 && row.key.indexOf('undefined') == -1) })
        console.log('updated stuff:')
        console.log(tabs)
        console.log(tabpanels)
        console.log(this.opened)
        console.log(this.state.tabvalue)
        this.setState({ tabs, tabpanels, newlistings: {} }, () => {
            this.loadtree()
            this.addtab({
                type: 'listing',
                label: res.name + ' (Listing)',
                id: res.advertiser_id + '-' + res.listing_id,
            })
        })
    }

    render() {
        const { classes } = this.props
        let tabpanels = this.state.tabpanels.map((body, i) => {
            console.log('tabpanel ' + i)
            console.log(body)
            return <TabPanel key={i} value={this.state.tabvalue} index={i} className={classes.tabbody}>
                {body}
            </TabPanel>
        })
        let tabs = this.state.tabs.map((label, i) => {
            let closebutton = i == 0 ? <div style={{ display: 'inline-flex', flexBasis: 'auto', flexGrow: '0', flexShrink: '0', height: '1px', width: '20px' }}>&nbsp;</div> : <IconButton size="small" onClick={() => this.closetab(i)}>
                <Close style={{ color: '#fff', height: '15px' }} />
            </IconButton>

            return <Tab key={i} id={i} className={classes.tab} label={<div>
                {label}
                {closebutton}
            </div>}
            />

        })
        console.log('this.state.treestate')
        console.log(this.state.treestate)
        console.log(this.state.tree)

        return (
            <div className={classes.page}>
                <PanelGroup
                    panelWidths={[
                        { size: treeWidth + 18, minSize: 50, resize: 'dynamic' },
                        { minSize: 100, resize: 'dynamic' },
                    ]}
                //onUpdate={(sizes) => { this.setState({accountWindowSize: sizes[1].size}) }}
                //                <Button disabled={this.state.selectedtype != 'account'} onClick={this.newlisting}><ListIcon />Add Listing</Button>
                >
                    <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%', height: (window.innerHeight - header) + 'px' }}>
                        {/* <Toolbar className={classes.tb}>
                            <div><Tooltip title="Add Folder" arrow><Button color="inherit"><img alt='Add Folder' className={classes.folder} src="data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 122.879 103.39' enable-background='new 0 0 122.879 103.39' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M2.971,18.676l3.314-0.001v-8.14c0-0.817,0.334-1.561,0.87-2.098c0.541-0.539,1.284-0.873,2.102-0.873h3.233V2.971 c0-0.817,0.333-1.561,0.869-2.098C13.899,0.333,14.643,0,15.46,0h36.251c0.817,0,1.561,0.333,2.099,0.872 c0.539,0.535,0.873,1.278,0.873,2.099v4.593h48.155c0.821,0,1.565,0.333,2.101,0.869c0.537,0.537,0.87,1.281,0.87,2.102v8.14h3.342 c0.82,0,1.564,0.334,2.101,0.87c0.536,0.537,0.87,1.281,0.87,2.102c-0.015,0.238-0.023,0.355-0.065,0.585l-3.188,23.435 c8.447,5.653,14.011,15.282,14.011,26.209c0,17.404-14.109,31.515-31.515,31.515c-11.842,0-22.157-6.534-27.542-16.192H13.975 c-1.043,0-2.024-0.206-2.918-0.578c-0.937-0.39-1.776-0.965-2.49-1.673c-0.695-0.691-1.267-1.52-1.691-2.434 c-0.42-0.904-0.697-1.896-0.809-2.928l-6.051-57.63c-0.084-0.812,0.17-1.586,0.65-2.175c0.477-0.588,1.182-0.998,1.997-1.08 L2.971,18.676L2.971,18.676z M105.931,67.26h-0.004l-0.003-0.001h-0.003l-0.003-0.001h-0.002h-0.002h-0.004l-0.003-0.001h-0.003 l-0.003-0.001h-0.004h-0.003l-0.004-0.001h-0.003l-0.003-0.001h-0.004h-0.003h-0.001h-0.003l-0.003-0.001h-0.003l-0.004-0.001 h-0.003h-0.004l-0.003-0.001h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.001h-0.003l-0.003-0.001h-0.003h-0.004h-0.003h-0.004 l-0.003-0.001h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.001h-0.003h-0.003h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.004 h-0.003h-0.004h-0.003h-0.004l0,0h-0.003l-0.004-0.001h-0.003h-0.003h-0.004h-0.007h-0.003h-0.004h-0.003h-0.004h-0.003h-5.77 h-3.953v-9.723c0-0.862-0.706-1.571-1.571-1.571h-6.116c-0.862,0-1.572,0.709-1.572,1.571v9.723h-9.723l0,0 c-0.862,0-1.571,0.709-1.571,1.575v6.112c0,0.866,0.709,1.575,1.571,1.572h9.727v4.76v4.963v0.017v0.017v0.007l0.001,0.011v0.017 l0.001,0.013v0.005l0.001,0.017l0.001,0.017v0.002l0.002,0.015l0.001,0.017l0.001,0.008l0.001,0.01l0.002,0.016l0.002,0.014v0.004 l0.002,0.016l0.003,0.017v0.003l0.003,0.014l0.002,0.017l0.002,0.009l0.001,0.007l0.004,0.017l0.002,0.015l0.001,0.002l0.004,0.016 l0.003,0.017l0.001,0.004l0.003,0.012l0.004,0.016l0.003,0.011l0.001,0.006l0.005,0.016l0.004,0.016l0.005,0.016l0.005,0.016 l0.001,0.006l0.004,0.01l0.005,0.016l0.004,0.011l0.001,0.005l0.006,0.016l0.006,0.015v0.002l0.005,0.014l0.006,0.015l0.003,0.007 l0.004,0.009l0.006,0.015l0.005,0.013l0.001,0.003l0.007,0.015l0.007,0.015l0.001,0.002l0.006,0.013l0.007,0.015l0.003,0.008 l0.004,0.007l0.007,0.015l0.007,0.013l0.001,0.001l0.007,0.015l0.008,0.014l0.002,0.004l0.006,0.011l0.008,0.014l0.005,0.009 l0.003,0.005l0.009,0.015l0.008,0.013l0.009,0.015l0.009,0.014l0.003,0.004l0.006,0.009l0.009,0.014l0.006,0.01l0.003,0.004 l0.009,0.013l0.01,0.014v0.001l0.009,0.012l0.01,0.013l0.004,0.006l0.006,0.007l0.01,0.013l0.008,0.011l0.002,0.002 c0.289,0.365,0.735,0.602,1.232,0.602h6.113c0.497,0,0.944-0.235,1.233-0.602l0.001-0.001l0.009-0.012l0.01-0.013l0.004-0.005 l0.006-0.008l0.009-0.013l0.008-0.011l0.002-0.002l0.009-0.014l0.01-0.013l0.001-0.003l0.008-0.011l0.009-0.013l0.009-0.014 l0.008-0.014l0.009-0.013V87.04l0.009-0.014l0.008-0.014l0.002-0.004l0.006-0.011l0.008-0.014l0.005-0.009l0.003-0.005l0.008-0.015 l0.007-0.014l0.001-0.001l0.007-0.014l0.007-0.015l0.003-0.006l0.004-0.009l0.007-0.015l0.006-0.011l0.001-0.004l0.007-0.015 l0.002-0.003l0.01-0.024l0.001-0.002l0.006-0.016l0.003-0.007l0.003-0.008l0.006-0.016l0.005-0.013l0.001-0.002l0.006-0.016 l0.005-0.016l0.002-0.003l0.004-0.012l0.005-0.016l0.003-0.01l0.002-0.006l0.005-0.016l0.004-0.016h0.001l0.004-0.016l0.004-0.017 l0.002-0.005l0.003-0.011l0.004-0.016l0.002-0.012l0.001-0.005l0.004-0.016l0.004-0.017v-0.001l0.003-0.015l0.003-0.017 l0.001-0.007l0.002-0.01l0.003-0.016l0.002-0.014l0.001-0.003l0.002-0.017l0.002-0.017l0.001-0.003l0.001-0.014l0.002-0.017 l0.001-0.009l0.001-0.008l0.002-0.017l0.001-0.016v-0.002l0.001-0.017l0.001-0.017l0.001-0.005v-0.013l0.001-0.017v-0.011 l0.001-0.006v-0.018v-0.017v-4.963v-4.76h2.694h5.984h1.044c0.862,0,1.571-0.71,1.571-1.572v-6.116 C107.288,68.026,106.696,67.365,105.931,67.26L105.931,67.26z M103.285,42.696l2.456-18.061L9.143,24.626H6.265l5.706,54.375 c0.037,0.351,0.126,0.683,0.259,0.979s0.311,0.561,0.521,0.775c0.164,0.162,0.354,0.293,0.562,0.379l0.037,0.018 c0.186,0.072,0.393,0.112,0.617,0.112h47.306c-0.924-2.966-1.422-6.119-1.422-9.39c0-17.405,14.11-31.515,31.515-31.515 C95.584,40.36,99.608,41.191,103.285,42.696L103.285,42.696z M12.227,13.515v5.147l87.64-0.93v-4.218H51.711 c-0.821,0-1.564-0.333-2.102-0.871c-0.536-0.536-0.87-1.28-0.87-2.1V5.951h-30.31v4.593c0,0.816-0.333,1.559-0.87,2.097 c-0.543,0.542-1.285,0.874-2.101,0.874H12.227L12.227,13.515z'/%3E%3C/g%3E%3C/svg%3E" /> Add Folder</Button></Tooltip></div>
                            <div><Tooltip title="Remove Folder" arrow><Button color="inherit"><img className={classes.folder} src="data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 122.879 103.39' enable-background='new 0 0 122.879 103.39' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M2.971,18.676l3.314-0.001v-8.14c0-0.817,0.334-1.561,0.87-2.098c0.541-0.539,1.284-0.873,2.102-0.873h3.233V2.971 c0-0.817,0.333-1.561,0.869-2.098C13.899,0.333,14.643,0,15.46,0h36.251c0.817,0,1.561,0.333,2.099,0.872 c0.539,0.535,0.873,1.278,0.873,2.099v4.593h48.155c0.821,0,1.565,0.333,2.101,0.869c0.537,0.537,0.87,1.281,0.87,2.102v8.14h3.342 c0.82,0,1.564,0.334,2.101,0.87c0.536,0.537,0.87,1.281,0.87,2.102c-0.015,0.238-0.023,0.355-0.065,0.585l-3.188,23.435 c8.447,5.653,14.011,15.282,14.011,26.209c0,17.404-14.109,31.515-31.515,31.515c-11.842,0-22.157-6.534-27.542-16.192H13.975 c-1.043,0-2.024-0.206-2.918-0.578c-0.937-0.39-1.776-0.965-2.49-1.673c-0.695-0.691-1.267-1.52-1.691-2.434 c-0.42-0.904-0.697-1.896-0.809-2.928l-6.051-57.63c-0.084-0.812,0.17-1.586,0.65-2.175c0.477-0.588,1.182-0.998,1.997-1.08 L2.971,18.676L2.971,18.676z M105.931,67.26h-0.004l-0.003-0.001h-0.003l-0.003-0.001h-0.002h-0.002h-0.004l-0.003-0.001h-0.003 l-0.003-0.001h-0.004h-0.003l-0.004-0.001h-0.003l-0.003-0.001h-0.004h-0.003h-0.001h-0.003l-0.003-0.001h-0.003l-0.004-0.001 h-0.003h-0.004l-0.003-0.001h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.001h-0.003l-0.003-0.001h-0.003h-0.004h-0.003h-0.004 l-0.003-0.001h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.001h-0.003h-0.003h-0.003h-0.004h-0.003l-0.004-0.001h-0.003h-0.004 h-0.003h-0.004h-0.003h-0.004l0,0h-0.003l-0.004-0.001h-0.003h-0.003h-0.004h-0.007h-0.003h-0.004h-0.003h-0.004h-0.003h-5.77 c-7.102,0-11.013,0-22.936,0l0,0c-0.862,0-1.571,0.709-1.571,1.575v6.112c0,0.866,0.709,1.575,1.571,1.572 c3.239,0,20.779,0,21.677,0h5.984h1.044c0.862,0,1.571-0.71,1.571-1.572v-6.116C107.288,68.026,106.696,67.365,105.931,67.26 L105.931,67.26z M103.285,42.696l2.456-18.061L9.143,24.626H6.265l5.706,54.375c0.037,0.351,0.126,0.683,0.259,0.979 s0.311,0.561,0.521,0.775c0.164,0.162,0.354,0.293,0.562,0.379l0.037,0.018c0.186,0.072,0.393,0.112,0.617,0.112h47.306 c-0.924-2.966-1.422-6.119-1.422-9.39c0-17.405,14.11-31.515,31.515-31.515C95.584,40.36,99.608,41.191,103.285,42.696 L103.285,42.696z M12.227,13.515v5.147l87.64-0.93v-4.218H51.711c-0.821,0-1.564-0.333-2.102-0.871 c-0.536-0.536-0.87-1.28-0.87-2.1V5.951h-30.31v4.593c0,0.816-0.333,1.559-0.87,2.097c-0.543,0.542-1.285,0.874-2.101,0.874H12.227 L12.227,13.515z'/%3E%3C/g%3E%3C/svg%3E" /> Remove Folder</Button></Tooltip></div>
                        </Toolbar> */}
                        <TreeView
                            className={classes.treepanel}
                            defaultCollapseIcon={<ArrowDropDownIcon />}
                            defaultExpandIcon={<ArrowRightIcon />}
                            defaultEndIcon={<div style={{ width: 24 }} />}
                            // onNodeToggle={this.handleTreeClick}
                        >
                            {this.state.tree || []}
                        </TreeView>
                    </div>
                    <div
                        className={classes.tabpanel}
                    >
                        <Tabs
                            id='accounttabs'
                            className={classes.tabs}
                            value={this.state.tabvalue}
                            onChange={this.handleChange}
                            scrollButtons="auto"
                            variant='scrollable'
                            TabIndicatorProps={{ style: { display: 'none' } }}
                        >
                            {tabs}
                        </Tabs>
                        {tabpanels}
                    </div>
                </PanelGroup>
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        user_role: state.user_role,
        reload_tree_id: state.reload_tree_id,
    }
}

export default withStyles(styles)(connect(mapStateToProps)(AccountAdmin))
